// services/dashboard/formatHistoryIndicators.js

/**
 * Función para extraer el primer history de cada indicador único
 * @param {any} data - Datos crudos del reporte
 * @returns {Array} Arreglo de objetos con el historial procesado
 */
export function extractFirstHistories(data) {
    const results = [];
    const processedIndicators = new Set();

    if (!data || !data.data) return [];

    // Iterar sobre todas las fechas
    for (const date of Object.keys(data.data)) {
        const dateData = data.data[date];

        for (const companyKey of Object.keys(dateData)) {
            const company = dateData[companyKey];

            for (const groupKey of Object.keys(company)) {
                // Saltar campos que no son grupos
                if (groupKey === 'company_type' || groupKey === 'indicator_name') {
                    continue;
                }

                const group = company[groupKey];

                for (const indicatorKey of Object.keys(group)) {
                    // Si ya procesamos este indicador, saltarlo
                    if (processedIndicators.has(indicatorKey)) {
                        continue;
                    }

                    const indicator = group[indicatorKey];

                    // Verificar si tiene histories
                    if (indicator.histories && typeof indicator.histories === 'object') {
                        const indicatorName = indicatorKey.split('__')[1]?.replace(/_/g, ' ') || indicatorKey;

                        // Tomar solo el PRIMER término dentro de histories
                        const firstTermKey = Object.keys(indicator.histories)[0];
                        const history = indicator.histories[firstTermKey];

                        if (history) {
                            results.push({
                                indicatorId: indicatorKey,
                                indicatorName: indicatorName.charAt(0).toUpperCase() + indicatorName.slice(1),
                                termKey: firstTermKey,
                                termName: history.term_name || firstTermKey,
                                sum: Number(history.sum?.toFixed(2)) || 0,
                                avg: Number(history.avg?.toFixed(2)) || 0,
                                median: Number(history.median?.toFixed(2)) || 0,
                                max: Number(history.max?.toFixed(2)) || 0,
                                min: Number(history.min?.toFixed(2)) || 0,
                                count: history.count || 0
                            });

                            // Marcar como procesado
                            processedIndicators.add(indicatorKey);
                        }
                    }
                }
            }
        }
    }

    return results;
}